
$(document).ready(function(){
    $('[data-toggle="tooltip"]').tooltip();

    $('.datetimepicker-group').datetimepicker({
        format: 'YYYY/MM/DD'
    });

    $('.duallistbox').bootstrapDualListbox();


    var options = {
        url: function(query) {
            return "/client_profiles/client_search.json?q[first_name_or_email_or_phone_number_cont]=" + query;
        },
        getValue: "name",
        requestDelay: 500
    };
    $('*[data-behavior="autocomplete"]').easyAutocomplete(options);

});
